import { render, staticRenderFns } from "./dialogConfirm.vue?vue&type=template&id=a4956296"
import script from "./dialogConfirm.vue?vue&type=script&lang=js"
export * from "./dialogConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports